import { Channel, Conversation, UserInterface, UserVarsMap } from "@swivl-mono/types";
import { InsetTabsComponent } from "@swivl-mono/ui";
import { useState } from "react";

import "./UserDetails.scss";
import { UserDetailsCustomerDetailsView } from "./View/UserDetails.CustomerDetails.View";
import { UserDetailsLocationLookupView } from "./View/UserDetails.LocationLookupView";

interface Props {
  user: UserInterface;
  userVars: UserVarsMap | undefined;
  conversation?: Conversation;
}

export default function UserDetails({ user, userVars }: Props) {
  const [selectedTab, setSelectedTab] = useState("details");

  return (
    <div className="UserDetailsContainer overflow-y-auto h-full bg-grey-100 [&::-webkit-scrollbar]:bg-transparent [&::-webkit-scrollbar]:rounded-md [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:bg-grey-400 [&::-webkit-scrollbar-thumb]:rounded-md">
      <div className="px-6">
        <InsetTabsComponent
          items={[
            // { id: "assistant", label: <BsLightningChargeFill />, badge: false },
            { id: "details", label: "Customer Details", badge: false },
            { id: "inventory", label: "Inventory", badge: false },
            // { id: 'history', label: 'History', badge: false },
            // { id: 'notes', label: 'Notes', badge: true },
          ]}
          selectedItem={selectedTab}
          itemSelected={(id) => {
            setSelectedTab(id);
          }}
        />

        {selectedTab === "details" && <UserDetailsCustomerDetailsView user={user} userVars={userVars} />}
        {selectedTab === "inventory" && <UserDetailsLocationLookupView user={user} userVars={userVars} />}
      </div>
    </div>
  );
}
